import { LayoutThree } from '../../Layout/CommonStyle'
import RecentJobs from '../../Common/RecentJobs'
import TestList from '../../Common/TestList'
import Main from '../../Home/Main'

function MentorMain() {
  return (
    <LayoutThree>
      <Main />
      <TestList />
      <RecentJobs />
    </LayoutThree>
  )
}

export default MentorMain
